<script lang="ts" setup>
  import { reactiveOmit } from '@vueuse/core';
  import type { CalendarCellTriggerProps } from 'reka-ui';
  import { CalendarCellTrigger, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { buttonVariants } from '@ui/components/button';
  import { cn } from '@ui/utils/utils';

  const props = withDefaults(
    defineProps<CalendarCellTriggerProps & { class?: HTMLAttributes['class'] }>(),
    {
      as: 'button',
    },
  );

  const delegatedProps = reactiveOmit(props, 'class');

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <CalendarCellTrigger
    data-slot="calendar-cell-trigger"
    :class="
      cn(
        buttonVariants({ variant: 'ghost', size: 'sm' }),
        'size-8 p-0 font-normal aria-selected:opacity-100 cursor-default',
        '[&[data-today]:not([data-selected])]:bg-accent [&[data-today]:not([data-selected])]:text-accent-foreground',
        // Selected
        'data-[selected]:bg-primary data-[selected]:text-primary-foreground data-[selected]:opacity-100 data-[selected]:hover:bg-primary data-[selected]:hover:text-primary-foreground data-[selected]:focus:bg-primary data-[selected]:focus:text-primary-foreground',
        // Disabled
        'data-[disabled]:text-muted-foreground data-[disabled]:opacity-50',
        // Unavailable
        'data-[unavailable]:text-destructive-foreground data-[unavailable]:line-through',
        // Outside months
        'data-[outside-view]:text-muted-foreground',
        props.class,
      )
    "
    v-bind="forwardedProps"
  >
    <slot />
  </CalendarCellTrigger>
</template>
